import { render, staticRenderFns } from "./LoginData.vue?vue&type=template&id=4015a4a2&"
import script from "./LoginData.vue?vue&type=script&lang=js&"
export * from "./LoginData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports